import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs';

function normalizeLang(v?: string | null): string {
  return (v ?? '').split('.')[0] || 'en-us';
}

@Component({
  selector: 'flex-privacy-policy-more-info',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './more-info.component.html',
  styleUrl: './more-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MoreInfoComponent {
  private readonly translateService = inject(TranslateService);
  readonly locale = toSignal(this.translateService.onLangChange.pipe(map((e) => normalizeLang(e.lang))), { initialValue: normalizeLang(this.translateService.getCurrentLang() || this.translateService.getFallbackLang()) });
  readonly isUsLocale = computed(() => this.locale() === 'en-us');
}
